/* Marcel Afters — quiet motion, every page (24 Sep 2026).
   Things rise into place once as they scroll in; nothing loops, nothing blocks reading.
   Content is visible without this script, and reduced-motion visitors get no movement. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  var SEL = [
    '.ma-look__item', '.ma-look__copy',
    '.ma-tiles__item', '.ma-slider__item', '.ma-slider__head',
    '.ma-faq', '.ma-flash__copy',
    '.product-grid__item', '.product-list__item', 'product-card', '.resource-list__item',
    '.section h2', '.product-details', '.product-information__media'
  ].join(',');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('ma-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function arm(root) {
    var seen = new Map();
    [].slice.call((root || document).querySelectorAll(SEL)).forEach(function (el) {
      if (el.classList.contains('ma-rv') || el.closest('.ma-intro, header, .header, footer')) return;
      // only animate things below the first screen, so nothing above the fold ever flashes
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;
      var p = el.parentElement, i = seen.get(p) || 0; seen.set(p, i + 1);
      el.style.setProperty('--ma-i', Math.min(i, 5));
      el.classList.add('ma-rv');
      io.observe(el);
    });
  }
  function start() { document.documentElement.classList.add('ma-motion'); arm(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // product grids re-render on filter/sort: arm the new cards too
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) arm(n); }); }); })
    .observe(document.body, { childList: true, subtree: true });
})();

/* Model shots lead every product (Bruce, 24 Sep). Photos fill the 4:5 card; flat garment shots stay whole. */
(function () {
  function tag(img) {
    function set() { if (!img.naturalWidth) return; var src = img.currentSrc || img.src, art = /artcard|hero-card/i.test(src) || (img.naturalWidth === img.naturalHeight && img.naturalWidth >= 1800); var ph = !art && (img.naturalHeight / img.naturalWidth > 1.05 || /\.jpe?g/i.test(src)); img.classList.toggle('ma-photo', ph); img.classList.toggle('ma-art', art); img.classList.toggle('ma-wide', ph && img.naturalWidth / img.naturalHeight > 1.25); }
    if (img.complete) set(); else img.addEventListener('load', set, { once: true });
  }
  function run(root) {
    [].slice.call((root || document).querySelectorAll('.product-grid__card img, product-card img, .product-card img')).forEach(tag);
    // 25 Sep: collection-index tiles — only clearly portrait, non-art photos are tagged (so art is never cover-cropped)
    [].slice.call((root || document).querySelectorAll('.ma-coll-index .ma-tile__img img')).forEach(function (img) {
      function set() { if (!img.naturalWidth) return; var src = img.currentSrc || img.src; img.classList.toggle('ma-photo', !/artcard|hero-card|ma-tile-/i.test(src) && img.naturalHeight / img.naturalWidth > 1.12); }
      if (img.complete) set(); else img.addEventListener('load', set, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Chic layer (Bruce, 24 Sep: "where is the responsiveness and all the chicness"):
   header settles on scroll, headlines slide up from a mask, images drift with the scroll. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false, par = [];
  // 25 Sep: from 990px Horizon scrolls .page-wrapper, not the window, so read whichever is moving.
  function sy() { var pw = document.querySelector('.page-wrapper'); return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
  function onScroll() {
    root.classList.toggle('ma-scrolled', sy() > 24);
    if (!reduce && par.length) {
      var vh = window.innerHeight;
      par.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = ((r.top + r.height / 2) - vh / 2) / vh; // -1..1 across the screen
        el.style.setProperty('--ma-par', (p * -22).toFixed(1) + 'px');
      });
    }
    ticking = false;
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }
  function init() {
    par = [].slice.call(document.querySelectorAll('.ma-look__item img')); // tiles are art: never moved or scaled
    par.forEach(function (el) { el.classList.add('ma-par'); });
    // headline mask: wrap each section title so it can slide up from below a clean edge
    if (!reduce) [].slice.call(document.querySelectorAll('.ma-look__copy h2, .ma-slider__head h2, .ma-faq h2, .ma-flash__h, main .section h2')).forEach(function (h) {
      if (h.querySelector('.ma-mask') || h.closest('.ma-intro')) return;
      var r = h.getBoundingClientRect(); if (r.top < window.innerHeight * 0.9) return;
      h.innerHTML = '<span class="ma-mask"><span class="ma-mask__in">' + h.innerHTML + '</span></span>';
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { h.classList.add('ma-mask-in'); io.disconnect(); } }); }, { threshold: 0.3 });
      io.observe(h);
    });
    onScroll();
  }
  window.addEventListener('scroll', req, { passive: true });
  document.addEventListener('scroll', req, { passive: true, capture: true }); // catches .page-wrapper scrolling on desktop
  window.addEventListener('resize', req);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Product page: a slim sticky "Add to cart" bar on phones once the real button scrolls away. It presses the real button. */
(function () {
  function init() {
    var bar = document.querySelector('.ma-sticky-buy'), real = document.querySelector('.product-form-buttons .add-to-cart-button, .add-to-cart-button');
    if (!bar || !real || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar); bar.hidden = false;
    new IntersectionObserver(function (es) { es.forEach(function (e) {
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
    }); }, { threshold: 0 }).observe(real);
    bar.querySelector('button').addEventListener('click', function () {
      if (real.disabled || real.getAttribute('aria-disabled') === 'true') { real.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      real.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
